import { FormOptionDto } from "src/models"

export const toOptions = <T>( data: T[], valueKey: keyof T, labelKey: keyof T) : FormOptionDto[] => {
  return data.map((item) => ({
    value: String(item[valueKey]),
    label: String(item[labelKey])
  }))
}

export const classNames = (...classes: (string | false | null | undefined)[]): string => {
  return classes.filter(Boolean).join(' ');
}

export const toDateOnly = (date: Date): string => {
  console.log("toDateOnly called with date:", date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

export const fromDateOnly = (value: string): Date => {
  console.log("fromDateOnly called with value:", value);
    const [year, month, day] = value.split("-").map(Number);
    return new Date(year, month - 1, day);
}


// export const toUTC = (date : Date) : Date = {return date}